import React, {FC} from 'react';

import {ConversationHighlightModel} from '../../../models/api/conversationHighlightModel';
import {VisualConversationSendersModel} from '../../../models/api/conversationSendersModel';
import {CellRecipientTeammatesProps} from '../../inboxes/cells/content/cell/cellRecipient';
import {ConversationSendersFormatter} from './senders/conversationSendersFormatter';
import {DiscussionSendersFormatter} from './senders/discussionSendersFormatter';

/*
 * Props.
 */

export interface SendersFormatterProps extends CellRecipientTeammatesProps {
  /** The senders to render. */
  conversationSenders: VisualConversationSendersModel;
  conversationHighlight: ConversationHighlightModel | undefined;

  isCellSelected: boolean;
  hasAssignee: boolean;
  isUserTracking: boolean;
  userId?: number;

  isDiscussion: boolean;
}

/*
 * Component.
 */

export const SendersFormatter: FC<SendersFormatterProps> = (props) => {
  const {isDiscussion} = props;

  if (isDiscussion) {
    return <DiscussionSendersFormatter {...props} />;
  }

  return <ConversationSendersFormatter {...props} />;
};
